import React from 'react';
import * as tags from './_privacy_policy.tags';
import arrowImage from '~/assets/privacy_policy/left_arrow.svg';
import { Link } from 'gatsby';
import { SECTION_IDS } from '~/constants';

export const PrivacyPolicy: React.FC = () => (
  <tags.PolicyWrapper>
    <tags.Title>PRIVACY POLICY</tags.Title>
    <tags.PolicyContainer>
      <tags.Text>
        ご入力いただいた個人情報は、当社の個人情報保護管理者のもとで、厳重なセキュリティ対策を施し、適正な個人情報の管理を実施いたします。
      </tags.Text>
      <tags.Text>
        なお、ご入力いただいた個人情報につきましては、以下の目的で利用いたします。
      </tags.Text>
      <tags.Text>
        ・当社サービスに関する情報の提供・収集のため
        <br />
        ・当社サービスに関する情報、セミナー、その他情報のご案内のため
        <br />
        ・当社のマーケティング活動における顧客分析・統計調査
      </tags.Text>
      <tags.Text>
        当社では、個人情報を上記に記載している利用目的の範囲内で委託先に開示する場合および、法令に基づいて提供する場合を除き、あらかじめご本人から同意を得ることなく第三者に開示または提供することはありません。なお、委託先に個人情報を開示する場合には、当社が定める安全対策基準を満たす事業者を選定し、適切な管理・監督をおこないます。
      </tags.Text>
      <tags.Text>
        ご入力いただく情報につきましては、皆様の自由なご判断に基づいて行なっていただいておりますが、必要な情報をご入力いただけない場合は、当社サービスに関する情報等が提供できない場合がございますのでご了承ください。
      </tags.Text>
    </tags.PolicyContainer>
    <tags.BackButtonContainer>
      <Link
        to={`/#${SECTION_IDS.CONTACT}`}
        style={{
          textDecoration: 'none',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <tags.LeftSideBox>
          <tags.ArrowContainer>
            <tags.Arrow src={arrowImage} alt=">" />
          </tags.ArrowContainer>
        </tags.LeftSideBox>
        <tags.RightSideBox>
          <tags.TextBox>BACK</tags.TextBox>
        </tags.RightSideBox>
      </Link>
    </tags.BackButtonContainer>
  </tags.PolicyWrapper>
);
